var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 7.75678V9.49363C8.88889 9.81205 8.63889 10.0726 8.33333 10.0726H7.77778V7.75678H8.88889ZM2.22222 7.75678V10.0726H1.66667C1.36111 10.0726 1.11111 9.81205 1.11111 9.49363V7.75678H2.22222ZM5 0.230469C2.23889 0.230469 0 2.56363 0 5.441V9.49363C0 10.4547 0.744444 11.2305 1.66667 11.2305H3.33333V6.59889H1.11111V5.441C1.11111 3.20047 2.85 1.38836 5 1.38836C7.15 1.38836 8.88889 3.20047 8.88889 5.441V6.59889H6.66667V11.2305H8.33333C9.25556 11.2305 10 10.4547 10 9.49363V5.441C10 2.56363 7.76111 0.230469 5 0.230469Z",
    fill: "#8C5F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneIcon);
export default __webpack_public_path__ + "static/media/headphone_icon.d94c3145f49715c276c257a9291fecd3.svg";
export { ForwardRef as ReactComponent };